<div *ngIf="isAnalyzing; else interviewPage" class="analyzing-container">
  <div class="loader"></div>
  <h2>Analyzing Your Interview...</h2>
  <p>Our AI is processing your responses and generating a detailed interview report. Please don't refresh the page</p>

  <div class="analyzing-steps">
    <div class="step"><i class="bi bi-cpu"></i> Analyzing Voice Tone</div>
    <div class="step"><i class="bi bi-chat-text"></i> Evaluating Answers</div>
    <div class="step"><i class="bi bi-person-badge"></i> Checking Confidence</div>
    <div class="step"><i class="bi bi-graph-up"></i> Preparing Report</div>
  </div>

  <div class="progress-loader"></div>
  <p class="progress-text">Please wait while we prepare your report...</p>
</div>

<ng-template #interviewPage>
  <div class="interview-page">
    <div class="top-bar">
      <div class="left">
        <span class="live-dot"></span>
        <span class="live-text">LIVE</span>
        <span class="divider">|</span>
        <span class="title">{{sessionService.value.role_title}}</span>
      </div>

      <div class="center">
        <div class="duration-box">
          <p>Duration</p>
          <span>{{ timeRemaining }}</span>
        </div>
      </div>

      <div class="right">
        <button class="end-btn" (click)="openExitInterviewDialog()">
          <i class="bi bi-box-arrow-right"></i> End Interview
        </button>
      </div>
    </div>

    <div class="main-content">
      <div class="left-section">
        <div class="video-container">
			  <video #videoElement autoplay muted playsinline class="main-video"></video>
			      <span class="you-label">You</span>		  
          <div class="interviewer-small">
          <img [src]="getInterviewerImage()" alt="Interviewer">
            <span class="name">{{ sessionService.value.interviewer_name || 'Priya Sharma' }}</span>
      </div>
        </div>
      </div>

      <div class="right-section">
        <div class="conversation-box">
          <h4>Conversation</h4>
          <p class="sub">Live transcript of the interview</p>


          <div class="chat-window" #chatWindow *ngIf="chatLog.length; else waiting">
            <div class="chat-message" *ngFor="let msg of chatLog; trackBy: trackByIndex"
              [ngClass]="{ user: msg.role === 'user', ai: msg.role === 'assistant' }">
              <ng-container *ngIf="msg.role === 'user'; else aiMsg">
                <div class="header-row user-header">
                  <span class="name">
                    <i class="bi bi-person-workspace"></i>
                    You
                  </span>
                </div>
                <div class="message-body user-body">
                  <div class="msg-text">{{ msg.content }}</div>
                </div>
              </ng-container>

              <ng-template #aiMsg>
                <div class="header-row ai-header">
                  <span class="name">
                    <i class="bi bi-robot"></i>
                    {{ sessionService.value.interviewer_name || 'Interviewer' }}
                  </span>
                </div>
                <div class="message-body ai-body">
                  <div class="msg-text">{{ msg.content }}</div>
                </div>
              </ng-template>
            </div>
          </div>

          <ng-template #waiting>
            <p class="waiting">Listening to you...</p>
          </ng-template>
        </div>

        <div class="mic-bar">
          <i class="bi bi-mic-fill"></i>
          <span>Listening to you...</span>
        </div>

        <audio #remoteAudio autoplay></audio>
      </div>
    </div>
  </div>
</ng-template>